import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchCategories = createAsyncThunk(
    'category/fetchCategories',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if(limit != null){
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.categoryListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

export const fetchAllCategories = createAsyncThunk(
    'category/fetchAllCategories',
    async (limit = null, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                apiUrls.categoryListing,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const categorySlice = createSlice({
    name: 'category',
    initialState: {
        categories: [],
        limitLessCategory: [],
        limitLessLoader: false,
        data: [],
        loading: false,
        error: null
    },
    reducers: {
        clearCategoryError: (state) => {
            state.error = null;
        },
        clearCategories: (state) => {
            state.categories = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAllCategories.pending, (state) => {
                state.limitLessLoader = true;
                state.error = null;
            })
            .addCase(fetchAllCategories.fulfilled, (state, action) => {
                state.limitLessLoader = false;
                state.limitLessCategory = action.payload;
            })
            .addCase(fetchAllCategories.rejected, (state, action) => {
                state.limitLessLoader = false;
                state.error = action.payload;
            });
    }
});

export const { clearCategoryError, clearCategories } = categorySlice.actions;
export default categorySlice.reducer;